const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

const THRESHOLDS: {
  limit: number;
  unit: Intl.RelativeTimeFormatUnit;
  seconds: number;
}[] = [
  { limit: MINUTE, unit: 'second', seconds: 1 },
  { limit: HOUR, unit: 'minute', seconds: MINUTE },
  { limit: DAY, unit: 'hour', seconds: HOUR },
  { limit: WEEK, unit: 'day', seconds: DAY },
  { limit: MONTH, unit: 'week', seconds: WEEK },
  { limit: YEAR, unit: 'month', seconds: MONTH },
];

export type RelativeTime = {
  value: number;
  unit: Intl.RelativeTimeFormatUnit;
};

export function toRelativeTime(
  date: string | Date,
  now: Date = new Date()
): RelativeTime {
  const elapsed = (new Date(date).getTime() - now.getTime()) / 1000;
  const magnitude = Math.abs(elapsed);

  const threshold = THRESHOLDS.find(({ limit }) => magnitude < limit);
  if (!threshold) {
    return { value: Math.trunc(elapsed / YEAR), unit: 'year' };
  }

  if (threshold.unit === 'second') {
    return { value: 0, unit: 'second' };
  }

  return {
    value: Math.trunc(elapsed / threshold.seconds),
    unit: threshold.unit,
  };
}
